import React from 'react';
import { Avatar, AvatarGroup, Button, Popover, Whisper } from 'rsuite';
import style from './ExAvatarTablePosAdmin.module.css';
import stringAvatar from 'utils/avatar-name';

const ExAvatarTablePosAdmin = ({ droguerias = [], max = 4 }) => {
    if (!Array.isArray(droguerias)) return null;

    const visibles = droguerias.slice(0, max);
    const ocultas = droguerias.slice(max);

    return (
        <AvatarGroup stack spacing={6}>
            {droguerias.length === 0 ? (
                <div className={style['container']}>
                    <Button
                        className={style['container-button']}
                        appearance="ghost"
                        startIcon={<img className={style['icon']} src="/assets/images/power.svg" alt="power" />}
                    >
                        <span>Conectar droguerías</span>
                    </Button>
                </div>
            ) : (
                <>
                    {visibles.map((elem, idx) => (
                        <div key={idx} className={style['tooltip-container']}>
                            <Avatar circle className={style['avatars']}>
                                <span className={style['text-avatar']}>{stringAvatar(elem.name, false, null)}</span>
                            </Avatar>
                            <span className={style['tooltip-text']}>{elem.name}</span>
                        </div>
                    ))}

                    {ocultas.length > 0 && (
                        <Whisper
                            placement="bottom"
                            speaker={
                                <Popover>
                                    {ocultas.map((item, i) => (
                                        <React.Fragment key={i}>
                                            <div className={style['container-n-avatars']}>
                                                <Avatar circle className={style['avatars']}>
                                                    <span className={style['text-avatar']}>
                                                        {stringAvatar(item.name,false,null)}
                                                    </span>
                                                </Avatar>
                                                <p className={style['text-avatar-n-droguerias']}>{item.name}</p>
                                            </div>
                                            <hr className={style['line-divider']} />
                                        </React.Fragment>
                                    ))}
                                </Popover>
                            }
                        >
                            <Avatar circle size="md" className={style['avatar-component-all']}>
                                {`+${ocultas.length} ${ocultas.length === 1 ? 'droguería' : 'droguerías'}`}
                            </Avatar>
                        </Whisper>
                    )}
                </>
            )}
        </AvatarGroup>
    );
};

export default ExAvatarTablePosAdmin;
